// Shared UI helpers for avatars, badges, and formatting.

// Deterministic avatar background from a name/id — same input, same color.
const AVATAR_COLORS = [
  '#3b5bdb', '#0891b2', '#7c3aed', '#c026d3', '#db2777',
  '#e11d48', '#ea580c', '#ca8a04', '#16a34a', '#0d9488',
];

export function avatarColor(seed = '') {
  let hash = 0;
  const s = String(seed);
  for (let i = 0; i < s.length; i++) {
    hash = (hash << 5) - hash + s.charCodeAt(i);
    hash |= 0;
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

// Up to two initials from a display name ("Nana Owusu Kyere" -> "NK").
export function getInitials(name = '') {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

// Visual style token per staff role, consumed by the .badge--* classes.
export function roleBadgeClass(role = '') {
  switch (role) {
    case 'super-user': return 'badge--brand';
    case 'admin': return 'badge--slate';
    case 'audit': return 'badge--warn';
    case 'compliance': return 'badge--purple';
    default: return 'badge--slate';
  }
}

export function roleLabel(role = '') {
  const map = {
    'super-user': 'Super User',
    admin: 'Admin',
    audit: 'Audit',
    compliance: 'Risk & Compliance',
  };
  return map[role] || role;
}
